export default __webpack_public_path__ + "6a34c4024a997270ddf8734103c3d521.svg";